import { render } from "./AssetsView.vue?vue&type=template&id=cddfbf7a"
import script from "./AssetsView.vue?vue&type=script&lang=js"
export * from "./AssetsView.vue?vue&type=script&lang=js"

import exportComponent from "D:\\develop\\app\\cw\\financial\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__